"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyToClipboard = void 0;
var useCopyToClipboard_1 = require("./useCopyToClipboard");
Object.defineProperty(exports, "useCopyToClipboard", { enumerable: true, get: function () { return useCopyToClipboard_1.useCopyToClipboard; } });
//# sourceMappingURL=index.js.map